import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { SignalTileContent } from 'widgets/signalTiles/signalTile/components/SignalTileContent';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { pfeTileProps } from './pfeTileProps';
import { pfeStreamedDataSelectors } from 'widgets/signalTiles/pfeTile/state';
const { useSymbolStreamedData } = pfeStreamedDataSelectors;

export function PfeTileMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } =
        useMyPortfolioCapsuleConfigSlice<SignalTileConfigState>();
    const streamData = useSymbolStreamedData(symbol, config);

    return (
        <SignalTileContent
            streamData={streamData}
            config={config}
            className={'PfeTileChartContent'}
            {...pfeTileProps}
        />
    );
}
